import axios from "axios";

const BASE_URL = process.env.REACT_APP_API;

const instance = axios.create({
  baseURL: `${BASE_URL}/api/v1/`,
  timeout: 10000,
});

instance.interceptors.request.use((config) => {
  const configuration = config;
  if (!(configuration.url.includes("/auth-asociacion/" ) || ("/auth-naviera/" ) || ("/auth-agente-aduanal/" )  )) {
    const token = localStorage.getItem("token");
    configuration.headers.Authorization = `Token ${token}`;
  }
  return configuration;
});

/**
 *
 * @param {username} username
 * @param {*user password account} password
 */

const loginAgente = async (username, password) => {
  const user = {
    username,
    password,
  };
  try {
    const response = await instance.post("/auth-agente-aduanal/", user);
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("role", response.data.role);
    localStorage.setItem("agencia", response.data.agencia_aduanal_id);
    localStorage.setItem("id", response.data.id);
    localStorage.setItem("nombre_usuario", response.data.nombre_usuario);
    localStorage.setItem("user_create_permission", response.data.user_create_permission)
    instance.defaults.headers.common.Authorization = `Token ${response.data.token}`;
    return response.data;
  } catch (err) {
    return err.response
  }
};

const loginShipper = async (username, password) => {
  const user = {
    username,
    password,
  };
  try {
    const response = await instance.post("/auth-naviera/", user);
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("role", response.data.role);
    localStorage.setItem("naviera", response.data.naviera);
    localStorage.setItem("id", response.data.id);
    localStorage.setItem("nombre_usuario", response.data.nombre_usuario);
    instance.defaults.headers.common.Authorization = `Token ${response.data.token}`;
    return response.data;
  } catch (err) {
    return err.json();
  }
};

const loginAAAPVER = async (username, password) => {
  const user = {
    username,
    password,
  };
  try {
    const response = await instance.post("/auth-asociacion/", user);
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("role", response.data.role);
    localStorage.setItem("id", response.data.id);
    localStorage.setItem("nombre_usuario", response.data.nombre_usuario);
    instance.defaults.headers.common.Authorization = `Token ${response.data.token}`;
    return response.data;
  } catch (err) {
    return err.json();
  }
};

//Usuarios
const createUser = async (data, token) => {
  try {
    const response = await instance.post(`/usuario/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    return err.response
  }
}


const getUsers = async (
  token, 
  idAgente, 
  itemsPerPage,
  itemOffset,
  userName,
  ) => {
  try {
    const response = await instance.get(`/usuario/?q=&agencia_aduanal=${idAgente}&limit=${itemsPerPage}&offset=${itemOffset}&q=${userName}`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
} 


const getOneUser = async (idUser, token) => {
  try {
    const response = await instance.get(`/usuario/${idUser}/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
} 

const editOneUser = async (idUser, data, token) => {
  try {
    const response = await instance.put(`/usuario/${idUser}/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}


const deleteOneUser = async (idUser, token) => {
  try {
    const response = await instance.delete(`/usuario/${idUser}/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
} 

//Agencia
const createUserAgencia = async (data, token) => {
  try {
    const response = await instance.post(`/agencia-aduanal/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

const getOneUserAgencia = async (idAgente, token) => {
  try {
    const response = await instance.get(`/agencia-aduanal/${idAgente}/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}


const getAllUsersAgencia = async (itemsPerPage, itemOffset, searchParam, searchDebt, token, estado) => {
  try {
    const response = await instance.get(`/agencia-aduanal/?limit=${itemsPerPage}&offset=${itemOffset}&q=${searchParam}&nivel=${searchDebt}&estado=${estado}`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

const getMiAgenciaAduanal = async (idAgencia, token) => {
  try {
    const response = await instance.get(`/mi-agencia-aduanal/${idAgencia}/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}


const editOneUserAgencia = async (idAgente, data, token) => {
  try {
    const response = await instance.put(`/agencia-aduanal/${idAgente}/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}



const deleteOneUserAgencia = async (idAgente, token) => {
  try {
    const response = await instance.delete(`/agencia-aduanal/${idAgente}/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

//Solicitud

const createSolicitud = async (data, token) => {
  try {
    const response = await instance.post(`/solicitud/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

const getAllHistorySolicitudes = async (itemsPerPage, itemOffset, searchParam, estado, agenteId, token) => {
  try {
    const response = await instance.get(`/solicitud/?limit=${itemsPerPage}&offset=${itemOffset}&referencia=${searchParam}&estado=${estado}&agencia_aduanal=${agenteId}`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

const getAllAgentesList = async (search, token) => {
  try {
    const response = await instance.get(`/agencia-aduanal/?q=${search}`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    return response.data;
  } catch (err) {
    throw err;
  }
}

export const getAllContainersCorteDemoras = async (idSolicitud, search, itemsPerPage=10, itemOffset=0) => {
  try {
    const token = localStorage.getItem('token');
    const response = await instance.get(`/solicitud/${idSolicitud}/contenedor/?limit=${itemsPerPage}&offset=${itemOffset}&numero=${search}&estado=COR`,{
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

export const getAllContainersCNaviera = async (idSolicitud, search, itemsPerPage=10, itemOffset=0) => {
  try {
    const token = localStorage.getItem('token');
    const response = await instance.get(`/solicitud/${idSolicitud}/contenedor/?limit=${itemsPerPage}&offset=${itemOffset}&numero=${search}&estado=CNA`,{
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}



export const getAllContainersEIR = async (idSolicitud, search, itemsPerPage=10, itemOffset=0) => {
  try {
    const token = localStorage.getItem('token');
    const response = await instance.get(`/solicitud/${idSolicitud}/contenedor/?limit=${itemsPerPage}&offset=${itemOffset}&numero=${search}&estado=EIR`,{
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

const getTiposContenedor = async (search, naviera, token) => {
  try {
    const response = await instance.get(`/tipo-contenedor/?q=${search}&naviera=${naviera}&v=2`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

const crearContenedoresBL = async (contenedores,  solicitudid, token) => {
  try {
    return await instance.post(`/solicitud/${solicitudid}/crear-contenedores/`, {
      contenedores: contenedores,
    }, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
  } catch (err) {
    throw err;
  }
}


const procesarArchivoBL = async (fileName,  solicitudid, token) => {
  try {
    return await instance.post(`/solicitud/${solicitudid}/procesar-archivo/`, {
      filename: fileName,
    }, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
  } catch (err) {
    throw err;
  }
}



const getAllNavierasSolicitud = async (search, token) => {
  try {
    const response = await instance.get(`/navieras-habilitadas/?q=${search}`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}


const editSolicitud = async (idSolicitud, data, token) => {
  try {
    return await instance.put(`/solicitud/${idSolicitud}/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
  } catch (err) {
    throw err;
  }
}

const getOneSolicitud = async (idSolicitud, token) => {
  try {
    const response = await instance.get(`/solicitud/${idSolicitud}/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

const getAllSolicitud = async (
  itemsPerPage, 
  itemOffset, 
  referencia, 
  fechaInicio, 
  fechaFinal, 
  idAgente, 
  estado, 
  convenio,
  token,
  ordenar="") => {
  try {
    const response = await instance.get(
      `/solicitud/?limit=${itemsPerPage}&offset=${itemOffset}&referencia=${referencia}&fecha_creacion_inicio=${fechaInicio}&fecha_creacion_final=${fechaFinal}&agencia_aduanal=${idAgente}&estado=${estado}&convenio_colaboracion=${convenio}&ordenar=${ordenar}`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

const deleteOneSolicitud = async (idSolicitud, token) => {
  try {
    const response = await instance.delete(`/solicitud/${idSolicitud}/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}


//Contenedor
const createContainer = async (idSolicitud, data, token) => {
  try {
    return await instance.post(`/solicitud/${idSolicitud}/contenedor/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
  } catch (err) {
    return err.response
  }
}


const createMultipleContainer = async (idSolicitud, data, token) => {
  try {
    const response = await instance.post(`/solicitud/${idSolicitud}/importar-contenedores/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.status;
  } catch (err) {
    throw err;
  }
}

const editOneContainer = async (idSolicitud, idContenedor, data, token) => {
  try {
    const response = await instance.put(`/solicitud/${idSolicitud}/contenedor/${idContenedor}/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}


const getAllContainers = async (itemsPerPage, itemOffset, idSolicitud, containerNumber, containerStatus, token) => {
  try {
    const response = await instance.get(`/solicitud/${idSolicitud}/contenedor/?limit=${itemsPerPage}&offset=${itemOffset}&numero=${containerNumber}&estado=${containerStatus}`,{
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

const getOneContainer = async (idSolicitud, idContenedor, token) => {
  try {
    const response = await instance.get(`/solicitud/${idSolicitud}/contenedor/${idContenedor}/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

const deleteOneContainer = async (idSolicitud, idContenedor, token) => {
  try {
    const response = await instance.delete(`/solicitud/${idSolicitud}/contenedor/${idContenedor}/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

export const createMultiTodo = async (idSolicitud, data) => {
  try {
    const token = localStorage.getItem("token");
    return await instance.post(`/solicitud/${idSolicitud}/multi-todo/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
  } catch (err) {
    return err.response;
  }
}



export const createMultiEIR = async (idSolicitud, data) => {
  try {
    const token = localStorage.getItem("token");
    return await instance.post(`/solicitud/${idSolicitud}/multi-eir/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
  } catch (err) {
    return err.response;
  }
}

  
const createEIR = async (idSolicitud, idContenedor, data, token) => {
  try {
    const response = await instance.post(`/solicitud/${idSolicitud}/contenedor/${idContenedor}/eir/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

export const createMultiConfirmacionNaviera = async (idSolicitud, data) => {
  try {
    const token = localStorage.getItem("token");
    return await instance.post(`/solicitud/${idSolicitud}/multi-confirmacion-naviera/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
  } catch (err) {
    return err.response;
  }
}



export const createMultiCorteDemoras = async (idSolicitud, data) => {
  try {
    const token = localStorage.getItem("token");
    return await instance.post(`/solicitud/${idSolicitud}/multi-corte-demoras/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
  } catch (err) {
    return err.response;
  }
}


const createCorteDemoras = async (idSolicitud, idContenedor, data, token) => {
  try {
    const response = await instance.post(`/solicitud/${idSolicitud}/contenedor/${idContenedor}/corte-demoras/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.status;
  } catch (err) {
    throw err;
  }
}

const createDemoraAnticipada = async (idSolicitud, idContenedor, data, token) => {
  try {
    const response = await instance.post(`/solicitud/${idSolicitud}/contenedor/${idContenedor}/demoras-anticipadas/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.status;
  } catch (err) {
    throw err;
  }
}

const createConfNaviera = async (idSolicitud, idContenedor, data, token) => {
  try {
    const response = await instance.post(`/solicitud/${idSolicitud}/contenedor/${idContenedor}/confirmacion-naviera/`, data, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.status;
  } catch (err) {
    throw err;
  }
}


const getAllTimeRecords = async (idSolicitud, itemsPerPage, itemOffset, containerNumber, containerStatus, token) => {
  try {
    const response = await instance.get(`/solicitud/${idSolicitud}/tiempos/?limit=${itemsPerPage}&offset=${itemOffset}&numero=${containerNumber}&etapa=${containerStatus}`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

const obtainSecureRouteS3 = async (fileData, token) => {
  try {
    const response = await instance.post(`/obtener-url-plantilla/`, fileData, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};


//Mesages

const createMessageInNote = async (idSolicitud, token, data) => {
  try {
    const response = await instance.post(
      `/solicitud/${idSolicitud}/comentario/`, data, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
    return response.data;
  } catch (err) {
    throw err;
  }
}

const deleteMessageInNote = async (idSolicitud, idMessage, token) => {
  try {
    const response = await instance.delete(
      `/solicitud/${idSolicitud}/comentario/${idMessage}/`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
    return response.data;
  } catch (err) {
    throw err;
  }
}

const editMessageInNote = async (idSolicitud, idMessage, token, data) => {
  try {
    const response = await instance.put(
      `/solicitud/${idSolicitud}/comentario/${idMessage}/`, data, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
    return response.data;
  } catch (err) {
    throw err;
  }
}

const replyMessageInNote = async (idSolicitud, token, data) => {
  try {
    const response = await instance.post(
      `/solicitud/${idSolicitud}/comentario/`, data, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
    return response.data;
  } catch (err) {
    throw err;
  }
}


const getAllMessage = async (idSolicitud, itemsPerPage, itemOffset, token) => {
  try {
    const response = await instance.get(
      `/solicitud/${idSolicitud}/comentario/?limit=${itemsPerPage}&offset=${itemOffset}`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
    return response.data;
  } catch (err) {
    throw err;
  }
}

//Alerts

const getAllNotifications = async (itemOffset, itemsPerPage, token) => {
  try {
    const response = await instance.get(
      `/notificaciones/?limit=${itemsPerPage}&offset=${itemOffset}`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
    return response.data;
  } catch (err) {
    throw err;
  }
}


const getAllNavNotifications = async (token) => {
  try {
    const response = await instance.get(
      `/notificaciones/?limit=${100}`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
    return response.data;
  } catch (err) {
    throw err;
  }
}

const updateNotification = async (idNotificacion, fecha_visto, token) => {
  try {
    const response = await instance.put(
      `/notificaciones/${idNotificacion}/`, fecha_visto, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
    return response.data;
  } catch (err) {
    throw err;
  }
}

//DASHBOARD
const getDashboard = async (startingDate, endDate, token) => {
  try {
    const response = await instance.get(
      `/dashboard/?fecha_inicial=${startingDate}&fecha_final=${endDate}`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
    return response.data;
  } catch (err) {
    throw err;
  }
}


//QR CODE GEN
const getQRcode = async (idSolicitud, token) => {
  try {
    const response = await instance.get(
      `/pdf-qr/${idSolicitud}/`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
    return response.data;
  } catch (err) {
    throw err;
  }

}

export {
  BASE_URL,
  loginAgente,
  loginShipper,
  loginAAAPVER,
    //
  createUser,
  getUsers, 
  getOneUser,
  editOneUser,
  deleteOneUser,
  //   
  createUserAgencia,
  getOneUserAgencia,
  getAllUsersAgencia,
  getAllHistorySolicitudes,
  getTiposContenedor,
  //test
  getAllAgentesList,
  //
  getMiAgenciaAduanal,
  editOneUserAgencia,
  deleteOneUserAgencia,
   //
   createSolicitud,
   getAllNavierasSolicitud,
   editSolicitud,
   getAllSolicitud,
   deleteOneSolicitud,
   getOneSolicitud,
   //
   createContainer,
   createMultipleContainer,
   editOneContainer,
   getAllContainers,
   getOneContainer,
   deleteOneContainer,
   createEIR,
   createCorteDemoras,
   createDemoraAnticipada,
   createConfNaviera,
   getAllTimeRecords,
   obtainSecureRouteS3,
   //
   createMessageInNote,
   editMessageInNote,
   deleteMessageInNote,
   replyMessageInNote,
   getAllMessage,
   //
   getAllNotifications,
   getAllNavNotifications,
   updateNotification,
   //QR code
   getQRcode,
   //Dashboard
   getDashboard,
  // process
  procesarArchivoBL,
  crearContenedoresBL
}